import { render, staticRenderFns } from "./DefaultPopup.vue?vue&type=template&id=ec3a1318"
import script from "./DefaultPopup.vue?vue&type=script&lang=js"
export * from "./DefaultPopup.vue?vue&type=script&lang=js"
import style0 from "./DefaultPopup.vue?vue&type=style&index=0&id=ec3a1318&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports